import { Minus, Plus } from "@assets";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title2 } from "@components/Typography";
import { DEFAULT_DEPOSIT_ADJUSTMENT } from "@constants";
import { formatCurrency } from "@utils";
import { useStyles } from "./styles";
import { AmountAdjusterProps } from "./types";

export const AmountAdjuster = ({
  amount,
  onAmountChange,
  min,
  max,
  step = DEFAULT_DEPOSIT_ADJUSTMENT,
  label,
  style,
}: AmountAdjusterProps) => {
  const styles = useStyles();

  const canDecrement = amount > min;
  const canIncrement = amount < max;

  const decrement = () => {
    onAmountChange(Math.max(min, amount - step));
  };

  const increment = () => {
    onAmountChange(Math.min(max, amount + step));
  };

  return (
    <div style={{ ...styles.container, ...style }}>
      {label ? (
        <>
          <Body style={styles.label}>{label}</Body>
          <Spacing size={SpacingSizes.M} />
        </>
      ) : null}

      <Row style={styles.counterContainer}>
        <div
          style={{
            ...styles.circle,
            ...(!canDecrement ? styles.circleDisabled : {}),
          }}
          onClick={() => {
            if (canDecrement) decrement();
          }}
        >
          <Minus />
        </div>

        <Title2 style={styles.amount}>{formatCurrency(amount)}</Title2>

        <div
          style={{
            ...styles.circle,
            ...(!canIncrement ? styles.circleDisabled : {}),
          }}
          onClick={() => {
            if (canIncrement) increment();
          }}
        >
          <Plus />
        </div>
      </Row>
      <Spacing size={SpacingSizes.XXS} />
    </div>
  );
};
